import React from 'react';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {TILE_CHARACTERS} from '@/utils/constants';

const Header=({score,bestScore,openGallery,openHelp,openAchievements,resetGame,nextValue})=> {
  return (
    <div className="w-full flex flex-col gap-3">
      <div className="flex justify-between items-center">
        <div>
          <div className="text-2xl font-black text-[#ff7e5f] leading-none mb-1">
            萌趣方塊 2048
          </div>
          <p className="text-[10px] text-orange-400 font-bold uppercase tracking-widest">
            Cute Puzzle Game
          </p>
        </div>
        <div className="flex gap-2">
          <IconBtn onClick={openGallery} icon={FiIcons.FiBook} color="bg-blue-400" />
          <IconBtn onClick={openAchievements} icon={FiIcons.FiAward} color="bg-yellow-400" />
          <IconBtn onClick={openHelp} icon={FiIcons.FiHelpCircle} color="bg-green-400" />
          <IconBtn onClick={resetGame} icon={FiIcons.FiRefreshCcw} color="bg-red-400" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <ScoreCard label="分數" value={score} color="text-orange-500" />
        <ScoreCard label="最佳" value={bestScore} color="text-yellow-600" />
        <div className="bg-white/60 backdrop-blur-md rounded-2xl p-2 flex flex-col items-center justify-center shadow-sm border-b-4 border-blue-100">
          <span className="text-[9px] font-black text-blue-400 uppercase">下一個</span>
          <div className="text-2xl mt-0.5 animate-bounce">
            {TILE_CHARACTERS[nextValue]}
          </div>
        </div>
      </div>
    </div>
  );
};

const ScoreCard=({label,value,color})=> (
  <div className="bg-white/60 backdrop-blur-md rounded-2xl p-2 flex flex-col items-center justify-center shadow-sm border-b-4 border-gray-100">
    <span className="text-[9px] font-black text-gray-400 uppercase">{label}</span>
    <span className={`text-lg font-black ${color} leading-none mt-1`}>{value}</span>
  </div>
);

const IconBtn=({onClick,icon,color})=> (
  <button
    onClick={onClick}
    className={`${color} text-white p-2.5 rounded-xl shadow-md active:scale-90 transition-all border-b-2 border-black/10`}
  >
    <SafeIcon icon={icon} className="text-base" />
  </button>
);

export default Header;